import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { useViewType, ViewType } from '@eika/hooks';
import { DarkSkeleton } from '@eika/skeleton';

import { TransactionFormSkeleton } from '../../TransactionForm';

import './PaymentItemDetailsSkeleton.scss';

interface Props {
    numberOfRows?: number;
}

const PaymentItemDetailsSkeleton: React.FC<Props> = ({ numberOfRows = 4 }) => {
    const viewType = useViewType();
    const isMobile = viewType === ViewType.mobile;
    return isMobile ? (
        <div className="payment-item-details__skeleton">
            <div className="payment-item-details__skeleton-title">
                <DarkSkeleton height={25} width="30%" />
            </div>
            <div className="payment-item-details__skeleton-amount">
                <DarkSkeleton width="100%" height={120} />
            </div>
            <ul className="payment-item-details__skeleton-row-list">
                {Array.from(Array(numberOfRows)).map((_, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <li key={index} className="payment-item-details__skeleton-list-item">
                        <Skeleton className="payment-item-details__skeleton-text" height={14} width="50%" />
                        {index < 2 && (
                            <Skeleton
                                className="payment-item-details__skeleton-padding-bottom"
                                height={14}
                                width="40%"
                            />
                        )}
                        {index > 1 && (
                            <Skeleton
                                className="payment-item-details__skeleton-padding-bottom"
                                height={14}
                                width="0%"
                            />
                        )}
                    </li>
                ))}
            </ul>
        </div>
    ) : (
        <TransactionFormSkeleton titleClassName="payment-item-details__title-wrapper" />
    );
};

export default PaymentItemDetailsSkeleton;
